(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["takaa-header-match"] && !Shopify.designMode) return;
  try {
    const buildTakaaAnnouncement = () => {
    document.querySelectorAll('.cc-announcement .announcement__slider').forEach((slider) => {
      if (slider.dataset.takaaReady === 'true') return;
      const items = [...slider.querySelectorAll('.announcement__text')]
        .map((item) => item.textContent.trim())
        .filter(Boolean);
      if (!items.length) return;
      const track = document.createElement('div');
      track.className = 'takaa-marquee';
      const groupMarkup = items.map((item) => `<span class="takaa-marquee__item">${item}</span>`).join('');
      track.innerHTML = `<div class="takaa-marquee__group">${groupMarkup}</div><div class="takaa-marquee__group" aria-hidden="true">${groupMarkup}</div>`;
      slider.classList.add('takaa-enhanced');
      slider.append(track);
      requestAnimationFrame(() => {
        const groups = track.querySelectorAll('.takaa-marquee__group');
        const firstGroup = groups[0];
        const secondGroup = groups[1];
        if (!firstGroup || !secondGroup) return;
        const minimumWidth = Math.max(slider.clientWidth * 2, window.innerWidth * 2);
        let repeatCount = 1;
        while (firstGroup.scrollWidth < minimumWidth && repeatCount < 30) {
          firstGroup.insertAdjacentHTML('beforeend', groupMarkup);
          repeatCount += 1;
        }
        secondGroup.innerHTML = firstGroup.innerHTML;
        const distance = firstGroup.getBoundingClientRect().width;
        const duration = Math.max(80, distance / 42);
        track.style.setProperty('--takaa-marquee-duration', `${duration}s`);
        track.classList.add('takaa-marquee--ready');
      });
      slider.dataset.takaaReady = 'true';
    });
  };

  const closeTakaaDesktopMenus = (exceptItem) => {
    document.querySelectorAll('.main-nav__item--dropdown').forEach((item) => {
      if (item === exceptItem) return;
      const toggle = item.querySelector('.main-nav__toggle-btn');
      const child = item.querySelector('.main-nav__child');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (child) child.hidden = true;
      item.removeAttribute('data-takaa-open');
      item.classList.remove('is-open', 'is-visible');
    });
  };

  const openTakaaDesktopMenu = (item) => {
    if (!item) return;
    closeTakaaDesktopMenus(item);
    const toggle = item.querySelector('.main-nav__toggle-btn');
    const child = item.querySelector('.main-nav__child');
    item.setAttribute('data-takaa-open', 'true');
    item.classList.add('is-open', 'is-visible');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (child) child.hidden = false;
  };

  const resetTakaaDesktopMenus = () => {
    if (!window.matchMedia('(min-width: 1024px)').matches) return;
    document.querySelectorAll('.main-nav__item--dropdown').forEach((item) => {
      const toggle = item.querySelector('.main-nav__toggle-btn');
      const child = item.querySelector('.main-nav__child');
      if (!toggle || !child) return;
      toggle.setAttribute('aria-expanded', 'false');
      child.hidden = true;
      item.removeAttribute('data-takaa-open');
      item.classList.remove('is-open', 'is-visible');
    });
  };

  const tuneTakaaMobileWhatsApp = () => {
    const sourceIcon = document.querySelector('.takaa-header-whatsapp svg');
    document.querySelectorAll('main-menu .main-menu__content a[href*="wa.me"], main-menu .main-menu__content a[href*="whatsapp"]').forEach((link) => {
      if (link.dataset.takaaWhatsappReady === 'true') return;
      const number = link.textContent.trim() || '01044633975';
      const label = document.createElement('span');
      const numberElement = document.createElement('strong');
      label.className = 'takaa-mobile-whatsapp__label';
      label.textContent = 'Hot Line';
      numberElement.className = 'takaa-mobile-whatsapp__number';
      numberElement.textContent = number;
      link.replaceChildren();
      if (sourceIcon) link.append(sourceIcon.cloneNode(true));
      link.append(label, numberElement);
      link.dataset.takaaWhatsappReady = 'true';
    });
  };

  const removeTakaaMobileDuplicateLinks = () => {
    document.querySelectorAll('main-menu .main-menu__content').forEach((content) => {
      const links = [...content.querySelectorAll('a')];
      const whatsappIndex = links.findIndex((link) => link.href.includes('wa.me') || link.href.includes('whatsapp'));
      if (whatsappIndex < 0) return;
      links.slice(whatsappIndex + 1).forEach((link) => {
        const label = link.textContent.replace(/\s+/g, ' ').trim();
        if (!['المتجر', 'أقسام الموقع', 'Shop', 'Categories'].includes(label)) return;
        const item = link.closest('li') || link.parentElement;
        if (item) {
          item.hidden = true;
          item.style.setProperty('display', 'none', 'important');
          item.dataset.takaaDuplicateLink = 'true';
        }
      });
    });
  };

  const arrangeTakaaCompactLinks = () => {
    const nav = document.querySelector('main-menu .main-nav');
    if (!nav) return;

    const requiredOrder = ['أجهزة المطبخ', 'الأجهزة المنزلية', 'العناية الشخصية'];
    const items = [...nav.children];

    requiredOrder.forEach((title, index) => {
      const item = items.find((candidate) => {
        const link = candidate.querySelector(':scope > .main-nav__row > .main-nav__item--primary');
        return link && link.textContent.replace(/\s+/g, ' ').trim() === title;
      });

      if (!item) return;
      item.style.setProperty('order', String(index + 1), 'important');
      item.dataset.takaaCompactLink = 'true';
    });
  };

  const closeTakaaMobileMenu = (immediate = false) => {
    const menu = document.querySelector('main-menu');
    if (!menu) return;
    const toggle = menu.querySelector('.main-menu__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    if (immediate || !menu.classList.contains('takaa-mobile-open')) {
      menu.classList.remove('takaa-mobile-open', 'takaa-mobile-opening', 'takaa-mobile-closing');
      document.body.classList.remove('takaa-mobile-menu-visible');
      return;
    }

    menu.classList.remove('takaa-mobile-opening');
    menu.classList.add('takaa-mobile-closing');

    window.clearTimeout(menu._takaaCloseTimer);
    menu._takaaCloseTimer = window.setTimeout(() => {
      menu.classList.remove('takaa-mobile-open', 'takaa-mobile-closing');
      document.body.classList.remove('takaa-mobile-menu-visible');
    }, 280);
  };

  const closeTakaaMobileSubmenus = (exceptItem) => {
    document.querySelectorAll('main-menu .main-nav__item--dropdown').forEach((item) => {
      if (item === exceptItem) return;
      const toggle = item.querySelector(':scope > .main-nav__row .main-nav__toggle-btn');
      const child = item.querySelector(':scope > .main-nav__child');
      item.classList.remove('is-open', 'is-visible');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (child) child.hidden = true;
    });
  };

  const toggleTakaaMobileSubmenu = (toggle) => {
    const item = toggle.closest('.main-nav__item--dropdown, .child-nav__item--toggle');
    if (!item) return;
    const child = item.querySelector(':scope > .main-nav__child, :scope > .child-nav__panel');
    if (!child) return;
    const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

    if (item.matches('.main-nav__item--dropdown')) {
      closeTakaaMobileSubmenus(item);
    }

    toggle.setAttribute('aria-expanded', String(willOpen));
    item.classList.toggle('is-open', willOpen);
    item.classList.toggle('is-visible', willOpen);
    child.hidden = !willOpen;
  };

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(min-width: 1024px)').matches) {
      const mobileToggle = event.target.closest('.main-menu__toggle');
      const mobileMenu = document.querySelector('main-menu');

      const compactLink = event.target.closest('main-menu:not(.takaa-mobile-open) .main-nav__item--primary');
      if (compactLink) {
        const directHref = compactLink.getAttribute('href');
        const parentItem = compactLink.closest('li');
        const fallbackLink = parentItem ? parentItem.querySelector('.main-nav__child a[href]:not([href="#"])') : null;
        const targetUrl = directHref && directHref !== '#' ? compactLink.href : fallbackLink?.href;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (targetUrl) window.location.assign(targetUrl);
        return;
      }

      if (mobileToggle && mobileMenu) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const willOpen = !mobileMenu.classList.contains('takaa-mobile-open');

        if (willOpen) {
          window.clearTimeout(mobileMenu._takaaCloseTimer);
          mobileMenu.classList.remove('takaa-mobile-closing');
          mobileMenu.classList.add('takaa-mobile-open', 'takaa-mobile-opening');
          document.body.classList.add('takaa-mobile-menu-visible');
          mobileToggle.setAttribute('aria-expanded', 'true');
          removeTakaaMobileDuplicateLinks();
          closeTakaaMobileSubmenus();

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              mobileMenu.classList.remove('takaa-mobile-opening');
            });
          });
        } else {
          closeTakaaMobileMenu();
        }
        return;
      }

      const topLevelRow = event.target.closest('main-menu .main-nav__row');
      const topLevelItem = topLevelRow?.parentElement;
      if (
        topLevelRow &&
        topLevelItem?.classList.contains('main-nav__item--dropdown') &&
        mobileMenu &&
        mobileMenu.classList.contains('takaa-mobile-open')
      ) {
        const rowToggle = topLevelRow.querySelector('.main-nav__toggle-btn');
        if (rowToggle) {
          event.preventDefault();
          event.stopImmediatePropagation();
          toggleTakaaMobileSubmenu(rowToggle);
          return;
        }
      }

      const submenuToggle = event.target.closest('main-menu .child-nav__item--toggle .main-nav__toggle-btn');
      if (submenuToggle && mobileMenu && mobileMenu.classList.contains('takaa-mobile-open')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleTakaaMobileSubmenu(submenuToggle);
        return;
      }

      const backButton = event.target.closest('main-menu .main-nav__item--back');
      if (backButton && mobileMenu && mobileMenu.classList.contains('takaa-mobile-open')) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const child = backButton.closest('.main-nav__child');
        const item = child?.parentElement;
        const toggle = item?.querySelector(':scope > .main-nav__row .main-nav__toggle-btn');

        if (item) item.classList.remove('is-open', 'is-visible');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (child) child.hidden = true;
        return;
      }

      const mobileLink = event.target.closest('main-menu .main-menu__content a[href]');
      if (mobileLink && mobileMenu && mobileMenu.classList.contains('takaa-mobile-open')) {
        const href = mobileLink.getAttribute('href');
        if (href && href !== '#') closeTakaaMobileMenu();
        return;
      }

      if (mobileMenu && mobileMenu.classList.contains('takaa-mobile-open') && !event.target.closest('.main-menu__content')) {
        closeTakaaMobileMenu();
      }
      return;
    }
    const toggle = event.target.closest('.main-nav__toggle-btn');
    if (toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const item = toggle.closest('.main-nav__item--dropdown');
      const willOpen = item.getAttribute('data-takaa-open') !== 'true';
      if (willOpen) openTakaaDesktopMenu(item);
      else closeTakaaDesktopMenus();
      return;
    }
    if (!event.target.closest('.main-nav__item--dropdown')) closeTakaaDesktopMenus();
  }, true);

  document.addEventListener('mouseover', (event) => {
    if (!window.matchMedia('(min-width: 1024px)').matches) return;
    const item = event.target.closest('.main-nav__item--dropdown');
    if (item) {
      openTakaaDesktopMenu(item);
      return;
    }
    if (event.target.closest('.main-nav')) closeTakaaDesktopMenus();
  }, true);

  document.addEventListener('mouseout', (event) => {
    if (!window.matchMedia('(min-width: 1024px)').matches) return;
    const nav = event.target.closest('.main-menu__content > nav:first-child');
    if (!nav || nav.contains(event.relatedTarget)) return;
    closeTakaaDesktopMenus();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeTakaaMobileMenu();
    closeTakaaDesktopMenus();
  });

  window.addEventListener('load', () => {
    buildTakaaAnnouncement();
    tuneTakaaMobileWhatsApp();
    removeTakaaMobileDuplicateLinks();
    arrangeTakaaCompactLinks();
    resetTakaaDesktopMenus();
  });
  document.addEventListener('shopify:section:load', () => {
    buildTakaaAnnouncement();
    tuneTakaaMobileWhatsApp();
    removeTakaaMobileDuplicateLinks();
    arrangeTakaaCompactLinks();
    resetTakaaDesktopMenus();
  });
  } catch(e) { console.error(e); }
})();

})();
